// 机构详情
import React from "react"
import LxHeader from "@/components/LxHeader/One"
// import { Link } from 'react-router-dom'
import styles from "./index.module.scss"
import defaultSetting from "@/setting"
import { getUrlParams } from "@/utils/util"
import { companyList } from "@/constants/companyInfo"
const sz_default_url = `/${defaultSetting.suiteKey}/pb/social.html`
const xz_default_url = `/${defaultSetting.suiteKey}/pb/school.html`

class Detail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      info: {},
    }
  }
  componentDidMount() {
    const flag = Number(getUrlParams().flag)
    this.setState({
      info: companyList.find((item) => item.id === flag),
    })
  }
  render() {
    return (
      <>
        <LxHeader></LxHeader>
        <main className={styles.detail}>
          <div className='banner lx-fz0'>
            <img className='lx-w100' src={this.state.info.bannerUrl} alt='banner' />
          </div>
          <div className='lx-container'>
            <div className='content'>
              <div className='logo-wrap lx-fz0 lx-flex-column-center'>
                <img className='lx-image-rendering logo-wrap-img' src={this.state.info.logo} alt='logo' />
                <span className='logo-wrap-title'>{this.state.info.title}</span>
              </div>
              <div className='lx-text-center lx-fz20 lx-mb30'>{this.state.info.name}</div>
              {this.state.info.content && this.state.info.content.length > 0
                ? this.state.info.content.map((item, index) => {
                    return <p key={index}>{item}</p>
                  })
                : ""}
            </div>

            <ul className='recruit-wrap lx-flex-row-between'>
              <li className='recruit-item lx-flex-row'>
                <div className='recruit-item-left lx-flex-grow-1 lx-pr15'>
                  <div className='recruit-title lx-fz20'>社会招聘</div>
                  {/* <div className="recruit-des lx-fz14">和优秀的人&nbsp;&nbsp;做有挑战的事</div> */}
                </div>
                <a target='_self' rel='noreferrer' href={this.state.info.szUrl ? this.state.info.szUrl : sz_default_url} className='recruit-handle-btn lx-flex-shrink-0 lx-flex-row-center'>
                  <span className='handle-btn-text'>了解更多</span>
                </a>
              </li>
              <li className='recruit-item lx-flex-row'>
                <div className='recruit-item-left lx-flex-grow-1 lx-pr15'>
                  <div className='recruit-title lx-fz20'>校园招聘</div>
                  {/* <div className="recruit-des lx-fz14">和优秀的人&nbsp;&nbsp;做有挑战的事</div> */}
                </div>
                <a target='_self' rel='noreferrer' href={this.state.info.xzUrl ? this.state.info.xzUrl : xz_default_url} className='recruit-handle-btn lx-flex-shrink-0'>
                  <span className='handle-btn-text'>了解更多</span>
                </a>
              </li>
            </ul>
          </div>
        </main>
      </>
    )
  }
}
export default Detail
